<template>
  <div class="grid grid-cols-1">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          % Cajas rechazadas por proveedor (Semanal)
        </h3>
      </div>
      <div class="panel-body">
        <apexchart
          height="350"
          width="100%"
          :options="chartOptions"
          :series="new_rejected_series"
        ></apexchart>
      </div>
    </div>
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          Distribución del top 10 de defectos por proveedor
        </h3>
      </div>
      <div class="panel-body">
        <apexchart
          height="350"
          width="100%"
          :options="chartOptions2"
          :series="defect_series"
        ></apexchart>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";
export default {
  name: "QualityReportsContainerProviderShowProcessGraphics",
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: 350,
          type: "line",
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        title: {
          text: "% Cajas rechazadas",
          align: "left",
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: this.weeks,
        },
        colors: [
          "#ef4444",
          "#f59e0b",
          "#84cc16",
          "#22d3ee",
          "#1e40af",
          "#6d28d9",
          "#e879f9",
          "#334155",
          "#10b981",
          "#ec4899",
          "#0ea5e9",
          "#a855f7",
          "#f97316",
          "#14b8a6",
          "#facc15"
        ],
      },

      chartOptions2: {
        chart: {
          type: "bar",
          height: 350,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 5,
            borderRadiusApplication: "end",
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: this.providers,
        },
        yaxis: {
          title: {
            text: "# defectos",
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return "# " + val + " defectos";
            },
          },
        },
        colors: [
          "#ef4444",
          "#f59e0b",
          "#84cc16",
          "#22d3ee",
          "#1e40af",
          "#6d28d9",
          "#e879f9",
          "#334155",
          "#10b981",
          "#ec4899",
          "#0ea5e9",
          "#a855f7",
          "#f97316",
          "#14b8a6",
          "#facc15"
        ],
      },
    };
  },
  props: {
    rejected_series: {
      type: Array,
      required: true,
    },
    defect_series: {
      type: Array,
      required: true,
    },
    providers: {
      type: Array,
      required: true,
    },
    weeks: {
      type: Array,
      required: true,
    },
  },

  computed: {
    new_rejected_series: function () {
      let series = [...this.rejected_series];
      return series.map((item) => {
        return {
          name: item.name,
          data: item.data.slice(0, -1),
        };
      });
    },
  },
};
</script>
